import React from "react";

import { resolveColor } from "utils/commonFunctions";

interface Props {
    size?: number;
    color?: string;
}

export const Lang = (props: Props) => {
    return (
        <svg
            width={props.size ?? 24}
            height={props.size ?? 24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.7765 11.25H6.26637C6.36699 8.954 6.92644 6.86015 7.80885 5.27181C7.90913 5.09131 8.01469 4.91564 8.12534 4.74577C7.71037 4.95338 7.29864 5.19784 6.90344 5.48312C5.31354 6.63079 3.97879 8.44373 3.7765 11.25ZM12 2.25C10.4795 2.25 8.07183 2.78974 6.0255 4.26689C3.94315 5.77003 2.25 8.23797 2.25 12C2.25 15.762 3.94315 18.23 6.0255 19.7331C8.07183 21.2103 10.4795 21.75 12 21.75C13.5205 21.75 15.9282 21.2103 17.9745 19.7331C20.0569 18.23 21.75 15.762 21.75 12C21.75 8.23797 20.0569 5.77003 17.9745 4.26689C15.9282 2.78974 13.5205 2.25 12 2.25ZM11.25 3.88876C10.5011 4.16558 9.75366 4.85983 9.12008 6.00027C8.37647 7.33878 7.86765 9.17425 7.76793 11.25H11.25V3.88876ZM11.25 12.75H7.76793C7.86765 14.8258 8.37647 16.6612 9.12008 17.9997C9.75366 19.1402 10.5011 19.8344 11.25 20.1112V12.75ZM8.12534 19.2542C8.01469 19.0844 7.90913 18.9087 7.80885 18.7282C6.92644 17.1399 6.36699 15.046 6.26637 12.75H3.7765C3.97879 15.5563 5.31354 17.3692 6.90344 18.5169C7.29864 18.8022 7.71037 19.0466 8.12534 19.2542ZM12.75 20.1112V12.75H16.2321C16.1323 14.8258 15.6235 16.6612 14.8799 17.9997C14.2463 19.1402 13.4989 19.8344 12.75 20.1112ZM16.2321 11.25H12.75V3.88876C13.4989 4.16558 14.2463 4.85983 14.8799 6.00027C15.6235 7.33878 16.1323 9.17425 16.2321 11.25ZM17.7336 11.25C17.633 8.954 17.0736 6.86015 16.1912 5.27181C16.0909 5.09131 15.9853 4.91564 15.8747 4.74577C16.2896 4.95338 16.7014 5.19784 17.0966 5.48312C18.6865 6.63079 20.0212 8.44373 20.2235 11.25H17.7336ZM17.7336 12.75C17.633 15.046 17.0736 17.1399 16.1912 18.7282C16.0909 18.9087 15.9853 19.0844 15.8747 19.2542C16.2896 19.0466 16.7014 18.8022 17.0966 18.5169C18.6865 17.3692 20.0212 15.5563 20.2235 12.75H17.7336Z"
                fill={props.color ?? resolveColor("--theme-icon-fill-default")}
            />
        </svg>
    );
};
